// extracted by mini-css-extract-plugin
module.exports = {"indretIntroduccioFoto":"IndretFormulariFoto_indretIntroduccioFoto__2FqkS"};